<template>
  <div id="downloadReport">
    <Modal v-model="showReportTemplate" title="体检报告" class-name="vertical-center-modal" :mask-closable="false">
      <p style="text-align:left">
        <MyCheckBox :enumList="reportTemplateList" :dataList.sync="reportTemplateIdList" :dataStr.sync="reportTemplateIds"/>
      </p>
      <div slot="footer">
        <Button type="primary" @click="download">下载</Button>
      </div>
    </Modal>

  </div>
</template>
<script>
import {_getBatchReportType, _download, _batchPrintReportByPdf} from "@/services/screening/screeningDatainfo";
import router from "@/router";
export default {
  name: "DownloadReport",
  data() {
    return {
      showReportTemplate: false,
      reportTemplateList: [],
      reportTemplateIdList: [],
      reportTemplateIds: "",
      init: "",
      search:{

      }
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    batchReportType() {
      _getBatchReportType(this.search).then(res => {
        if (res && res.errcode && res.errcode === 1 && res.data && res.data.length > 0) {
          this.reportTemplateIdList = [];
          for (let i = 0; i < res.data.length; i++) {
            let temp = res.data[i]
            this.reportTemplateList.push({value:temp.reportTemplateName, code:temp.reportTemplateId.toString()});
            this.reportTemplateIdList.push(temp.reportTemplateId.toString());
          }
          this.reportTemplateIds = this.reportTemplateIdList.toString();
          this.$forceUpdate();
        }else if (res && res.errcode && res.errcode !== 1){
          this.$Message.error(res.errmsg);
        }
      }).catch(() => {});
    },
    download() {
      if(!this.reportTemplateIdList || this.reportTemplateIdList.length === 0){
        this.$message.warning("请先选择报告模版");
        return;
      }
      this.search.reportTemplateIds = this.reportTemplateIdList;

      if(this.search.type && this.search.type === 1){
        this.simpleDownReport(this.search);
      }else{
        this.batchDownReport();
      }
    },
    simpleDownReport(row){
      let that=this
      _download({physicalId: row.physicalId, reportTemplateIds: row.reportTemplateIds}).then(res=>{
        if (res && res.errcode && res.errcode === 1){
          // this.$message.success("提交下载体检报告任务成功，请稍后到【导出记录管理】下载结果");
          this.showReportTemplate = false;
          that.$confirm('<h3 style="font-size: 16px;">提交下载体检报告任务成功，请稍后到【<span style="color: red;font-weight: bold;"> 导入导出管理 ->导出记录管理</span> 】下载结果</h3>', "系统提示", {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true, // 使用HTML片段
            customClass: 'custom-confirm-class',
            cancelButtonClass: 'custom-cancel-button',
            type: 'warning'
          }).then(() => {
            router.push("/batch-output-log/page");
          }).catch(() => {
          }).finally(()=>{})
        }else if (res && res.errcode && res.errcode !== 1){
          this.$Message.error(res.errmsg);
        }
      }).catch(e=>{
      })
    },
    batchDownReport(){
      let that=this
      _batchPrintReportByPdf(this.search).then(res=>{
        if (res && res.errcode && res.errcode === 1){
          // this.$message.success("提交下载体检报告任务成功，请稍后到【导出记录管理】下载结果");
          this.showReportTemplate = false;
          that.$confirm('<h3 style="font-size: 16px;">提交下载体检报告任务成功，请稍后到【<span style="color: red;font-weight: bold;"> 导入导出管理 ->导出记录管理</span> 】下载结果</h3>', "系统提示", {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true, // 使用HTML片段
            customClass: 'custom-confirm-class',
            cancelButtonClass: 'custom-cancel-button',
            type: 'warning'
          }).then(() => {
            router.push("/batch-output-log/page");
          }).catch(() => {
          }).finally(()=>{})
        }else if (res && res.errcode && res.errcode !== 1){
          this.$Message.error(res.errmsg);
        }
      }).catch(() => {});
    },
    handleModal(param) {
      this.search = param;
      this.reportTemplateList = [];
      this.reportTemplateIdList = [];
      this.showReportTemplate = true;
      this.batchReportType();
    },
  }
};
</script>
<style lang="postcss" scoped>
@media print {
  @page {
    size: 5cm 3cm;
    margin: 0;
    padding: 0;
    zoom: 100%;
  }
}

.bracodeheader {
  color: #000000;
  width: 266px;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  page-break-after: always
}

.bracodeheader-count {
  position: relative;
  top: 1px;
  z-index: 2;
  font-size: 15px;
  line-height: 24px;
}

.bracodeheader-pid {
  text-align: center;
  position: relative;
  top: -13px;
  z-index: 10;
  line-height: 22px;
  font-size: 15px;
}

.bracodeheader-item {
  position: relative;
  top: -15px;
  z-index: 10;
  line-height: 22px;
  font-size: 15px;
}
</style>
